import { store } from 'redux/store';
import { isAuthenticated } from 'utils/auth';
import { apiInterceptor } from 'utils/apiInterceptor';
/**
 * gets the list of chats
 */
export async function getChatCount(projectId, start, search) {
    const user = store?.getState()?.user

    if (isAuthenticated() && user) {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API}/manager/livestream/analytics/chats?projectId=${projectId}&sortBy=title&sortOrder=asc&limit=10&search=${search}&filter=&start=${start}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        return await response.json();
    }
}

export async function exportChatData(projectId, showcaseId) {
    const user = store?.getState()?.user

    if (isAuthenticated() && user) {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API}/manager/livestream/analytics/chats/${showcaseId}/export?projectId=${projectId}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        return await response.blob();
    }
}

export async function exportAllChatData(projectId) {
    const user = store?.getState()?.user

    if (isAuthenticated() && user) {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API}/manager/livestream/analytics/chats/export?projectId=${projectId}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        return await response.blob();
    }
}

export const getIframePolicies = () => {
    return {
        sandbox: "allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation allow-downloads allow-modals allow-presentation allow-same-origin",
        allow: "camera *; microphone *; accelerometer; magnetometer; autoplay; encrypted-media; gyroscope; geolocation; picture-in-picture; xr-spatial-tracking; webvr; vr; webxr; xr",
        allowVr: "yes",
        allowFullScreen: true,
        seamless: true,
        loading: 'lazy',
        frameBorder: '0'
    }
}